import React, { useState, useEffect } from 'react';
import './inicial.css';
import Footer from '../components/footer/footer';
import EncabezadoSincarrusel from '../components/encabezado/encabezado_sincarrusel';


function Administracion() {
  const [novedades, setNovedades] = useState([]);

  useEffect(() => {
    fetch('https://frenoux1.pythonanywhere.com/api/productos')
      .then((response) => response.json())
      .then((data) => {
        console.log('Datos de data.json:', data);

        // Filtra las novedades por la categoría "inicial"
        const novedadesFiltradas = data.filter((novedad) =>
          novedad.categoria.toLowerCase() === 'administracion'
        );

        setNovedades(novedadesFiltradas);
      })
      .catch((error) => console.error('Error al obtener datos:', error));
  }, []);


  const handleMoreInfoClick = (id) => {
    // Abre la página en una nueva pestaña
    window.open(`/pprimaria/${id}`, '_blank');
  };

  return (
    <div className="Inicial">
      <EncabezadoSincarrusel />

      <div>
        <h2 className="text-center mb-4">ADMINISTRACIÓN</h2>
        <section id="servicios" className="py-5">
          <div className="container">
            <h2 className="text-center mb-4">Novedades</h2>
            <div className="row">
              {novedades.map((novedad) => (
                <div className="col-lg-3 mb-4" key={novedad.id}>
                  <div className="card">
                    {/* Mostrar 'nombre' encima de la tarjeta */}
                    <div className="card-header">
                      <h5>{novedad.nombre}</h5>
                    </div>
                    <img
                      src={`https://frenoux1.pythonanywhere.com/static/assets/fotos_productos/${novedad.imagen}`}
                      className="card-img-top servicio-img"
                      alt={`Novedad ${novedad.id}`}
                    />

                    <div className="card-footer">
                      <p>ID: {novedad.id}</p>
                      <p>Fecha de Publicación: {novedad.fecha_publicacion}</p>
                      <p>Categoría: {novedad.categoria}</p>
                      <button
                        className="btn btn-primary"
                        onClick={() => handleMoreInfoClick(novedad.id)}
                      >
                        Más Información
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default Administracion;